export const LISTINGS_ROUTE_KEYS = {
  LISTINGS_LIST: "LISTINGS_LIST",
  CREATE_LISTING: "CREATE_LISTING",
};

export const LISTINGS_ROUTE_IDS = {
  [LISTINGS_ROUTE_KEYS.LISTINGS_LIST]: "/ScheduleList",
  [LISTINGS_ROUTE_KEYS.CREATE_LISTING]: `/CreateScheduleType`,
};
